// extracted by extract-css-chunks-webpack-plugin
module.exports = {"savingModal":"_1XmLQ","row":"_3_UVS","title":"_1v1RS","status":"_2m8N6","error":"_2YptT"};